import styles from './index.module.less';
import { useEffect } from 'react';
import { useMethods } from '@lhb/hook';
import { getSession, setSession } from '@lhb/cache';
import { Select } from 'antd';
import { RangeSelectEnum } from '../FirstScreenRight/ts-config';
import { useBigdataFn } from '@/common/utils/bigdata';
const youthMapDrawerRange = 'youthMapDrawerRange';

const options = [
  {
    label: '围栏内',
    value: RangeSelectEnum.inPolygon,
  },
  {
    label: '1km',
    value: RangeSelectEnum['1km'],
  },
  {
    label: '500m',
    value: RangeSelectEnum['500m'],
  },
  {
    label: '300m',
    value: RangeSelectEnum['300m'],
  },
  {
    label: '200m',
    value: RangeSelectEnum['200m'],
  },
  {
    label: '100m',
    value: RangeSelectEnum['100m'],
  },

];
/**
 * @Description 距离选择下拉框
 */
const RangeSelect = ({
  setRangeSelectValue,
  rangeSelectValue
}) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook

  const methods = useMethods({
    // 初始化获取距离
    getRange: () => {
      const range = getSession(youthMapDrawerRange);
      range && setRangeSelectValue(range);
    },
    // 保存距离
    saveRange: (value) => {
      setSession(youthMapDrawerRange, value);
    },
    // 距离选择下拉框改变
    onChange: (value) => {
      setRangeSelectValue(value);
      methods.saveRange(value);
      bigdataFn('0895baaa-8a06-4dc4-8ee2-f9f3fa7b3949',
        '详情页-选择范围',
        '点击了详情页-选择范围',
        { op_event: `选择的距离${value}`, });

    }
  });

  useEffect(() => {
    methods.getRange();
  }, []);

  return (
    <div className={styles.rangeSelect}>
      <Select
        className={styles.select}
        options={options}
        allowClear={false}
        placeholder='选择显示范围'
        value={rangeSelectValue}
        onChange={methods.onChange}
      />
    </div>
  );
};
export default RangeSelect;
